var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticStyle:{"vertical-align":"top"},attrs:{"dense":""},on:{"click":_vm.showInfo}},[_vm._v(" icon-information ")])}
var staticRenderFns = []

export { render, staticRenderFns }